import { styled } from "@nextui-org/react";

export const StyledContainer = styled("div", {
  padding: "20px",
  width: "100%",
  height: "calc(100% - 60px)",
  backgroundColor: "#555555",
});

export const StyledContainerGroupTable = styled("div", {
  width: "100%",
  height: "100%",
});

export const StyledContainerTable = styled("div", {
  backgroundColor: "#FFF",
  padding: "20px 10px 0px 10px",
  overflowY: "auto",
  height: "calc(100% - 44px)",
});

export const StyledCointanerList = styled("div", {
  backgroundColor: "#555555",
});

export const StyledUl = styled("ul", {
  display: "flex",
  listStyle: "none",
  ".active": {
    backgroundColor: "#FFF",
    marginTop: "0",
  },
  ".noActive": {
    color: "black",
  },
});

export const StyledLi = styled("li", {
  padding: "15px 35px",
  marginTop: "3px",
  cursor: "pointer",
  backgroundColor: "#DBDBDB",
  color: "#006bd6",
  fontWeight: "bold",
});
